import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIsGfCampaignLoaded } from 'store/dynamic-yields/selectors';
import { GfData } from 'utils/dynamic-yields';

/**
 * @name useDyDataCollect
 * @description Возвращает данные результата раюботы GF компании, если она применялась к продукту
 */
export const useDyDataCollect = (
  productRef: React.MutableRefObject<HTMLDivElement | null>
): GfData | undefined => {
  const isGfCampaignLoaded = useSelector(getIsGfCampaignLoaded);

  return useMemo((): GfData | undefined => {
    if (!isGfCampaignLoaded) {
      return undefined;
    }

    const productLabel = productRef.current?.querySelector('[data-tag]');

    if (!productLabel) {
      return undefined;
    }


    return {
      ...window.gf_campaign,
      // @ts-ignore
      productTag: productLabel?.dataset?.tag || null,
    };
  }, [productRef, isGfCampaignLoaded]);
};
